module.exports = __webpack_public_path__ + "static/clutch-top-100-companies-ce5a4b86038eeac6b30948a5428cf327.png";